import {useEffect, useRef} from "react";
import $ from 'jquery';
import 'jstree';

function JSTree({data, setSelectedIds}) {
    const treeRef = useRef(null);

    useEffect(() => {

        const $tree = $(treeRef.current);

        $tree.jstree({
            core: {
                data: data,
                check_callback: true,
                themes: {
                    icons: false,
                    responsive: false,
                    dots: false
                },
            },
            plugins: ['checkbox'],
        });

        $tree.on('changed.jstree', (e, data) => {
            const selectedNodes = data.selected;
            setSelectedIds(selectedNodes);
        });
        
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            $tree.jstree('destroy');
        };
    }, [data, setSelectedIds]);

    return <div ref={treeRef} className={"mt-4"}></div>;
}

export default JSTree;